import { SubcategoryDetailProps } from "../constants/settingsStructure";
import LegacySettingsRedirect from "../components/LegacySettingsRedirect";

const PhaseDetail = ({ subcategory, categoryId }: SubcategoryDetailProps) => {
  return (
    <LegacySettingsRedirect
      title={subcategory.label}
      description="Configure project phases to track task progression."
      categoryId={categoryId}
    />
  );
};

export default PhaseDetail;
